export const GLOBAL_LOADING_INCREMENT = 'GLOBAL_LOADING_INCREMENT'
export const GLOBAL_LOADING_DECREMENT = 'GLOBAL_LOADING_DECREMENT'
